// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Hrjw","resendInfoText":"OnGoingPaymentBox_resendInfoText__2ccOS"};